import { WithdrawalReason } from '../../../../investment/components/transfer/WithdrawalReason';

export default function WithdrawalReasonScreen() {
    return <WithdrawalReason />;
}
